module.exports = __webpack_public_path__ + "static/media/14UNEP24.4bf02592.jpg";